export default "__VITE_ASSET__BvEwdeLA__"